import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/Store";
import { ConfigRegistryType } from "types/apis/pilotInterfaces";

export interface ConfigRegistryReducerState {
  configRegistryData: ConfigRegistryType[];
}

const defaultState: ConfigRegistryReducerState = {
  configRegistryData: [],
};

export const configRegistrySlice = createSlice({
  name: 'configRegistry',
  initialState: defaultState,
  reducers: {
    setConfigRegistryData: (state, action: PayloadAction<ConfigRegistryType[]>) => {
      state.configRegistryData = action.payload;
    },
    clearConfigRegistryData: (state) => {
      state.configRegistryData = [];
    },
  },
});

export const {
  setConfigRegistryData,
  clearConfigRegistryData,
} = configRegistrySlice.actions;

export const selectConfigRegistryData = (state: RootState) => (state.configRegistry as ConfigRegistryReducerState).configRegistryData; 